export default __webpack_public_path__ + "static/media/explore_phone.10e4702c.svg";